<template>
  <v-container fluid class="white page__container--padding py-5">
    <div class="d-flex align-items-center gap-2">
      <v-icon
        v-if="!hideMaterialsTable"
        color="black"
        @click="returnToFamilies"
      >
        mdi mdi-arrow-u-left-top
      </v-icon>

      <div class="inner-shadow w-100">
        <v-row>
          <!-- families select -->
          <v-col cols="12" md="6" xl="2">
            <div class="d-flex align-items-center">
              <b>Familias:</b>
              <v-select
                v-model="selectedFamily"
                :items="familiesSelect"
                dense
                solo
                hide-details
                class="ml-2 z-index-10"
                @change="changeFamily()"
              />
            </div>
          </v-col>
          <!-- end families select -->

          <!-- more info -->
          <v-col cols="12" md="6" xl="4">
            <div
              v-if="!generatePDF"
              class="d-flex align-items-center justify-content-center h-100"
            >
              <b>Mostrar información por:</b>
              <div class="form-check ml-3">
                <input
                  id="renglonaje"
                  v-model="moreInfoFilter"
                  class="form-check-input"
                  type="radio"
                  value="renglonaje"
                  @change="loadData"
                />
                <label class="form-check-label" for="renglonaje">
                  Renglonaje
                </label>
              </div>

              <div class="form-check ml-3">
                <input
                  id="amounts"
                  v-model="moreInfoFilter"
                  class="form-check-input"
                  type="radio"
                  value="amounts"
                  @change="loadData"
                />
                <label class="form-check-label" for="amounts"> Montos </label>
              </div>
            </div>
          </v-col>
          <!-- end more info -->

          <!-- Genetics select -->
          <v-col cols="12" md="6" xl="2">
            <div class="d-flex align-items-center">
              <b>Genética:</b>
              <v-select
                v-model="selectedGenetic"
                :items="geneticsSelect"
                dense
                solo
                hide-details
                class="ml-2"
                :disabled="hideMaterialsTable"
                @change="loadData"
              />
            </div>
          </v-col>
          <!-- end Genetics select-->

          <!-- Period select-->
          <v-col cols="12" md="6" xl="4">
            <div class="d-flex align-items-center justify-content-center">
              <b>Periodo:</b>
              <v-select
                v-model="selectedYear"
                :items="years"
                dense
                solo
                hide-details
                class="ml-2 filter--select__red"
                @change="loadData"
              />
            </div>
          </v-col>
          <!-- end Period select-->
        </v-row>
      </div>
    </div>

    <div class="my-4">
      <menu-divisiones
        :loader="loadingDivisions"
        :active-d-i-v-i="selectedDivision"
        :divisiones="divisions"
        @filterDIVIs="changeDivision"
      />
    </div>

    <div class="inner-shadow mt-5">
      <div class="d-flex align-items-center">
        <!-- Search by Code Material -->
        <div class="d-flex align-items-center">
          <b>Código:</b>
          <v-text-field
            v-model="MATNR"
            dense
            solo
            hide-details
            class="ml-2"
            @keyup="filterInput"
          />
        </div>

        <div class="d-flex align-items-start ml-2">
          <v-btn class="button-red-round text-white" @click="sendCode()">
            Consultar
          </v-btn>
        </div>
        <!-- end Search by Code Material -->

        <div class="ml-auto">
          <!-- button export excel -->
          <v-btn class="btn-white">
            <vue-json-to-csv
              :show-labels="true"
              :json-data="topSellers"
              :csv-title="'Top1000'"
              class="d-flex align-items-center"
            >
              <span class="mr-2">Top 1000 + vendidos</span>
              <v-icon style="color: green"> mdi-file-excel </v-icon>
            </vue-json-to-csv>
          </v-btn>
          <!-- end button export excel -->
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="d-flex justify-content-end py-4">
      <search-input
        v-model="search"
        hide-details
        :default-width="'250px'"
        class="m-2"
      />
    </div>

    <!-- Tables -->
    <table-director-general
      :hide-materials-table="hideMaterialsTable"
      :filtered-items="hideMaterialsTable ? families : materials"
      :type-role="typeRole"
      :option="moreInfoFilter"
      :search="search"
      :loading="loading"
      :selected-year="selectedYear"
      @getMaterials="handleMaterials"
    />
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MenuDivisiones from './components/MenuDivisiones';
  import TableDirectorGeneral from './components/TableDirectorGeneral.vue';
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import VueJsonToCsv from 'vue-json-to-csv';
  import SearchInput from '@/components/SearchInput.vue';
  import userAuthOrStorage from '@/mixins/userAuthOrStorage';
  import numbersFormats from '@/mixins/numbersFormats';
  import { Roles, RolesLetter } from '@/core/constants/roleConstants';
  export default {
    components: {
      MenuDivisiones,
      VueJsonToCsv,
      SearchInput,
      TableDirectorGeneral,
    },
    mixins: [userAuthOrStorage, numbersFormats],
    data() {
      return {
        selectedYear: moment().year(),
        families: [],
        materials: [],
        loading: true,
        moreInfoFilter: 'renglonaje',
        divisions: [],
        selectedFamily: null,
        selectedGenetic: null,
        selectedDivision: 'todos',
        hideMaterialsTable: true,
        generatePDF: false,
        itemCSV: [],
        MVGR: null,
        MATNR: null,
        topSellers: [],
        search: '',
        genetics: [],
        familiesSelect: [],
        loadingDivisions: true,
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      years() {
        const currentYear = new Date().getFullYear();
        return Array.from({ length: 3 }, (_, i) => currentYear - i);
      },
      geneticsSelect() {
        const allOption = { text: 'Todas', value: null };
        const options = this.genetics.map((genetic) => ({
          text: `${genetic.CODDES} "${genetic.CODGEN}"`,
          value: genetic.CODGEN,
        }));
        return [allOption, ...options];
      },
      typeRole() {
        const role = {
          Regional: {
            code:
              '0' + this.removeLeftZeros(this.validateRegionalManagerCode()),
            letter: RolesLetter[Roles.REGIONAL_MANAGER],
          },
          Manager: {
            code: this.validateManagerCode(),
            letter: RolesLetter[Roles.MANAGER],
          },
          Director: {
            code: this.user.employee_number,
            letter: this.resolveRoleLetter(),
          },
        };

        return {
          code: role[this.$route.meta.role]?.code || null,
          letter: role[this.$route.meta.role]?.letter || null,
        };
      },
      typeMode() {
        return this.moreInfoFilter === 'renglonaje' ? 'RENGLONAJE' : 'MONTO';
      },
      divisionParam() {
        return this.selectedDivision === 'todos' ? '' : this.selectedDivision;
      },
    },
    mounted() {
      this.getDivisions();
      this.getFamilies();
      this.getBestSellingMaterials();
      this.getGenetics();
    },
    methods: {
      loadData() {
        this.hideMaterialsTable ? this.getFamilies() : this.getMaterials();
      },
      async getFamilies() {
        this.families = [];
        this.loading = true;

        try {
          let response = await axios.get('/renglonaje-by-family/families', {
            params: this.getRequestParams(),
          });
          this.families = response.data.data;

          if (this.familiesSelect.length === 0) {
            this.setFamiliesSelect();
          }
        } catch {
          this.$toast.error('Ocurrió un error al obtener las familias');
        } finally {
          this.loading = false;
        }
      },
      async getMaterials() {
        this.loading = true;
        this.materials = [];

        try {
          let response = await axios.get('/renglonaje-by-family/materials', {
            params: this.getRequestParams(),
          });
          this.materials = response.data.data;
        } catch {
          this.$toast.error('Ocurrió un error al obtener los materiales');
        } finally {
          this.loading = false;
        }
      },
      async getBestSellingMaterials() {
        try {
          let response = await axios.get('/renglonaje-by-family/best-sellers', {
            params: {
              PERIODO: this.selectedYear,
            },
          });

          if (response.data.data.length > 0) {
            let data = response.data.data;

            this.topSellers = data.map((value, index) => ({
              'N°': index + 1,
              'Grupo Material': value.MVGR4,
              Familia: value.BEZEI,
              Código: Number.parseInt(value.MATNR),
              Descripción: value.ARKTX,
              Piezas: value.PIEZAS,
              Monto: this.formatNumberOptionalDecimals(value.IMPORTE, '$', 0),
              'Prom. Mensual Piezas': this.formatNumberOptionalDecimals(
                value.PROM_MENSUAL_PIEZAS,
                '',
                0
              ),
              'Prom. Mensual Montos': this.formatNumberOptionalDecimals(
                value.PROM_MENSUAL_IMPORTE,
                '$',
                0
              ),
            }));
          }
        } catch {
          this.$toast.error(
            'Ocurrió un error al obtener los materiales más vendidos'
          );
        }
      },
      async getGenetics() {
        try {
          let response = await axios.get('/renglonaje-by-family/genetics');
          this.genetics = response.data.data;
        } catch {
          this.$toast.error(
            'Ocurrió un error al obtener el catálogo de genéticas'
          );
        }
      },
      async getDivisions() {
        try {
          let response = await axios.get('/renglonaje-by-family/divisions', {
            params: {
              CLAVE: this.typeRole.code,
              TIPO: this.typeRole.letter,
              VTWEG: this.user.VTWEG,
            },
          });

          const divisions = response.data.data;
          this.divisions = divisions.map((item) => item.DIVISION);
          this.loadingDivisions = false;
        } catch {
          this.$toast.error('Ocurrió un error al obtener las divisiones');
        }
      },
      sendCode() {
        this.selectedFamily = null;
        this.selectedGenetic = null;

        if (this.MATNR === '') {
          this.hideMaterialsTable = true;
          this.MATNR = null;
        } else {
          this.hideMaterialsTable = false;
        }

        this.loadData();
      },
      filterInput() {
        this.MATNR = this.MATNR.replace(/\D/g, '');
      },
      handleMaterials(data) {
        this.selectedFamily = data;
        this.hideMaterialsTable = false;
        this.loadData();
      },
      getRequestParams() {
        return {
          CLAVE: this.typeRole.code,
          TIPO: this.typeRole.letter,
          VTWEG: this.user.VTWEG,
          PERIODO: this.selectedYear,
          MODO: this.typeMode,
          FAMILIA: this.selectedFamily,
          GENETICA: this.selectedGenetic,
          BUSQUEDA: this.MATNR,
          DIVISION: this.divisionParam,
        };
      },
      setFamiliesSelect() {
        const allOption = { text: 'Todas', value: null };

        this.familiesSelect = [
          allOption,
          ...this.families.map((family) => ({
            text: `${family.MVGR4} ${family.BEZEI}`,
            value: family.MVGR4,
          })),
        ];
      },
      resolveRoleLetter() {
        const roleName = this.user.roles?.[0]?.name;
        return RolesLetter[roleName] || null;
      },
      changeDivision(data) {
        this.selectedDivision = data;
        this.selectedFamily = null;
        this.selectedGenetic = null;
        this.hideMaterialsTable = true;
        this.loadData();
      },
      returnToFamilies() {
        this.selectedGenetic = null;
        this.hideMaterialsTable = true;
        this.selectedFamily = null;
        this.loadData();
      },
      changeFamily() {
        this.hideMaterialsTable = true;
        this.loadData();
      },
    },
  };
</script>

<style scoped>
  .inner-shadow {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    opacity: 1;
    padding: 10px 20px;
    font-size: 16px;
  }
  .filter--select__red {
    max-width: 150px;
  }
  ::v-deep .filter--select__red .v-input__slot,
  ::v-deep .filter--select__red .v-input__control {
    background: transparent linear-gradient(180deg, #a82222 0%, #ff0000 100%) 0%
      0% no-repeat padding-box !important;

    z-index: 10;
  }
  ::v-deep .filter--select__red .v-input__slot .v-icon {
    color: #fff !important;
  }
  ::v-deep .filter--select__red .v-input__slot .v-label,
  ::v-deep .filter--select__red .v-input__slot .v-select__selection {
    color: #fff !important;
  }
  ::v-deep .v-input--is-disabled .v-input__slot {
    background: #e5e5e5 !important;
  }
  .z-index-10 {
    z-index: 10;
  }
</style>
